// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__NqJ6X","content":"styles_content__FUbM3","selectAll":"styles_selectAll__JlYL8"};